/* eslint-disable @typescript-eslint/naming-convention */
export interface INutritionalProperties {
  grossWeight: number;
  netWeight: number;
  suggestedQuantity: number;
  heminicIron_mg: number;
  noHeminicIron_mg: number;
  ascorbicAcid_mg: number;
  energy_kcal: number;
  cholesterol_mg: number;
  ethanol_g: number;
  sugar_g: number;
  pantothenicAcid_mg: number;
  biotin_ug: number;
  calcium_mg: number;
  zinc_mg: number;
  chloride_mg: number;
  copper_mg: number;
  chromium_ug: number;
  fluoride_ug: number;
  folate_ug: number;
  phosphorus_mg: number;
  magnesium_mg: number;
  manganese_mg: number;
  niacin_mg: number;
  potassium_mg: number;
  riboflavin_mg: number;
  selenium_ug: number;
  sodium_mg: number;
  thiamine_mg: number;
  vitaminA_ug: number;
  vitaminB12_ug: number;
  vitaminB6_mg: number;
  vitaminC_mg: number;
  vitaminD_ug: number;
  vitaminE_mg: number;
  vitaminK_ug: number;
  iodine_ug: number;
  choline_mg: number;
  totalFat_g: number;
  saturatedFats_g: number;
  monounsaturatedFats_g: number;
  polyunsaturatedFats_g: number;
  transFats_g: number;
  carbohydrate_g: number;
  protein_g: number;
  dietaryFiber_g: number;
  glycemicIndex: number;
  glycemicLoad: number;
  folicAcid_ug: number;
  portions?: number;
  measurementUnits?: number;
  grams?: number;
}

export const _DEFAULT_NUTRITIONAL_PROPERTIES: INutritionalProperties = {
  grossWeight: 0,
  netWeight: 0,
  suggestedQuantity: 0,
  heminicIron_mg: 0,
  noHeminicIron_mg: 0,
  ascorbicAcid_mg: 0,
  energy_kcal: 0,
  cholesterol_mg: 0,
  ethanol_g: 0,
  sugar_g: 0,
  pantothenicAcid_mg: 0,
  biotin_ug: 0,
  calcium_mg: 0,
  zinc_mg: 0,
  chloride_mg: 0,
  copper_mg: 0,
  chromium_ug: 0,
  fluoride_ug: 0,
  folate_ug: 0,
  phosphorus_mg: 0,
  magnesium_mg: 0,
  manganese_mg: 0,
  niacin_mg: 0,
  potassium_mg: 0,
  riboflavin_mg: 0,
  selenium_ug: 0,
  sodium_mg: 0,
  thiamine_mg: 0,
  vitaminA_ug: 0,
  vitaminB12_ug: 0,
  vitaminB6_mg: 0,
  vitaminC_mg: 0,
  vitaminD_ug: 0,
  vitaminE_mg: 0,
  vitaminK_ug: 0,
  iodine_ug: 0,
  choline_mg: 0,
  totalFat_g: 0,
  saturatedFats_g: 0,
  monounsaturatedFats_g: 0,
  polyunsaturatedFats_g: 0,
  transFats_g: 0,
  carbohydrate_g: 0,
  protein_g: 0,
  dietaryFiber_g: 0,
  glycemicIndex: 0,
  glycemicLoad: 0,
  folicAcid_ug: 0
};
/* eslint-enable @typescript-eslint/naming-convention */
